<template>
  <div id="layout" class="default" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
    <div class="wrapper">
      <sidebar :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }" />
      <div class="main" :class="{ pinned: sidebarPinned, collapsed: sidebarCollapsed }">
        <header>
          <top-header />
        </header>
        <section>
          <main class="content py-4 px-0">
            <router-view />
          </main>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import Sidebar from '@/components/Layout/Sidebar/Sidebar'
import TopHeader from '@/components/Layout/Header/Header'

export default {
  name: 'LayoutDefault',
  components: {
    Sidebar,
    TopHeader
  }
}
</script>
<style lang="scss">
#layout {
  &.default {
    position: fixed;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    .wrapper {
      width: 100%;
      display: flex;
      flex-direction: row;
      height: 100%;
      .main {
        width: 100%;
        display: flex;
        flex-direction: column;
        height: 100vh;
        overflow: hidden;
        padding-left: 160px;
        transition: padding-left .3s ease;
        &.pinned {
          padding-left: 40px;
        }
        &.collapsed {
          padding-left: 0;
        }
        > header {
          flex: 0 0 40px;
          border-bottom: 1px solid #eee;
          box-shadow: 0 0 10px rgba(0, 0, 0, .1) !important;
          background-color: #fff;
          position: relative;
          z-index: 10001;
        }
        section {
          flex: 1;
          overflow: hidden;
          .content {
            height: 100%;
            overflow: auto;
          }
        }
        footer {
          flex: 0 0 20px;
          background-color: #C14F4F;
        }
      }
    }
  }
}
</style>
